import { INotification } from 'services/notifications/types'

// `label` is already the translation key — render it via LocaleText, don't display it raw.
export type DateGroupLabel = 't_today' | 'earlier'

const startOfDay = (ts: number) => {
  const d = new Date(ts * 1000)
  d.setHours(0, 0, 0, 0)
  return d.getTime()
}

// Today / Earlier, computed client-side from created_at_ts. Yesterday folds into Earlier — there
// is no separate bucket for it. Preserves the incoming (already chrono-sorted) order within each group.
export function groupNotificationsByDate(
  items: INotification[]
): Array<{ label: DateGroupLabel; items: INotification[] }> {
  const todayStart = startOfDay(Math.floor(Date.now() / 1000))

  const groups: Record<DateGroupLabel, INotification[]> = {
    t_today: [],
    earlier: [],
  }

  items.forEach((item) => {
    const dayStart = startOfDay(item.created_at_ts)
    if (dayStart >= todayStart) groups.t_today.push(item)
    else groups.earlier.push(item)
  })

  return (['t_today', 'earlier'] as DateGroupLabel[])
    .filter((label) => groups[label].length > 0)
    .map((label) => ({ label, items: groups[label] }))
}
